import { render, staticRenderFns } from "./IconExclamationCircle.vue?vue&type=template&id=2973a682&scoped=true&"
import script from "./IconExclamationCircle.vue?vue&type=script&lang=js&"
export * from "./IconExclamationCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2973a682",
  null
  
)

export default component.exports